export enum SUBMISSION_TAB {
  ROSTER = 'ROSTER',
  SELECTED = 'SELECTED',
  SUBMITTED = 'SUBMITTED',
}
